// Helper di condivisione WhatsApp + clipboard.
//
// Problema su mobile (iOS Safari in particolare):
// navigator.clipboard.writeText() fallisce silenziosamente se chiamata
// dopo un await async (Safari pretende chiamate sincrone dentro un user
// gesture handler). Anche document.execCommand('copy') ha lo stesso
// vincolo.
//
// Soluzione qui: su mobile aprire direttamente WhatsApp con deep link
// (window.location.href = "whatsapp://..."), su desktop tenta clipboard
// con fallback execCommand. Se anche quello fallisce ritorna false e
// il chiamante mostra un dialog con textarea per copia manuale.

export function isMobileDevice(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
}

export function openWhatsApp(text: string) {
  // wa.me funziona sia da mobile (apre l'app installata) sia da desktop
  // (apre WhatsApp Web o desktop app, a seconda di cosa l'utente ha).
  const encoded = encodeURIComponent(text);
  const url = `https://wa.me/?text=${encoded}`;
  window.open(url, "_blank", "noopener,noreferrer");
}

export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator === "undefined") return false;

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // fallthrough al fallback
    }
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.top = "0";
    textarea.style.left = "0";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}

// Decide il modo migliore di condividere: su mobile apre WhatsApp,
// su desktop copia in clipboard. Ritorna 'whatsapp' | 'copied' | 'failed'.
// Il chiamante puo' usare il return per mostrare il toast / label appropriato.
export async function shareWhatsAppOrCopy(text: string): Promise<"whatsapp" | "copied" | "failed"> {
  if (isMobileDevice()) {
    openWhatsApp(text);
    return "whatsapp";
  }
  const ok = await copyToClipboard(text);
  return ok ? "copied" : "failed";
}
